import { Dropdown, Menu } from 'antd';
import {
	iconCertificate,
	iconGift,
	iconHome,
	iconService,
	iconTeleWhite
} from 'assets/icons';
import { imgBgLogin } from 'assets/images';
import classNames from 'classnames';
import { AppRoutes, ContractRoutes } from 'constants/appRoutes';
import { KEY_MENU, LINK_DEV } from 'constants/index';
import { isNullOrEmpty } from 'functions';
import useActiveMenu from 'hooks/useActiveMenu';
import useConvertMenu from 'hooks/useConvertMenu';
import useDevice from 'hooks/useDevice';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../Header';


export default function HeaderAndMenu(props) {
	const navigate = useNavigate();
	const { isMobile } = useDevice();
	const {
		checkRender,
		menuFilter,
		dataFuncSupport,
		setMenuActive,
		menuActive,
		isShowContract,
		isShowGift,
		isAdmin,
	} = useConvertMenu();

	let location = useLocation();

	const renderMenuApi = () => {
		return menuFilter.map((item, index) => {
			const isChildren = item?.children?.length > 0;

			if (!isChildren) {
				return (
					<Item
						key={item?.menuId}
						value={''}
						link={item.menuPath}
						text={item.menuName.toLowerCase()}
						isActiveProp={item.menuPath === location.pathname}
					/>
				);
			} else {
				const menuDropdown = (
					<Menu selectedKeys={menuActive} onClick={(e) => setMenuActive(e.key)}>
						{item.menuId === 'retrieve-contact' &&
						!isNullOrEmpty(dataFuncSupport)
							? item?.children?.map((itemChild, i) => {
									const isRenderChild = checkRender(dataFuncSupport, itemChild);
									if (isRenderChild) {
										return (
											<Menu.Item key={itemChild.menuId}>
												<div
													className='font-roboto-medium'
													onClick={() => {
														navigate(itemChild.menuPath);
													}}
												>
													{itemChild.menuName}
												</div>
											</Menu.Item>
										);
									} else return null;
							  })
							: item?.children?.map((itemChild, i) => {
									return (
										<Menu.Item key={itemChild.menuId}>
											<div
												className='font-roboto-medium'
												onClick={() => {
													navigate(itemChild.menuPath);
												}}
											>
												{itemChild.menuName}
											</div>
										</Menu.Item>
									);
							  })}
					</Menu>
				);

				const hasActive = item?.children?.find(
					(item) => item?.menuPath === location.pathname
				);

				return (
					<Dropdown
						trigger={['hover']}
						overlayStyle={{ minWidth: 150 }}
						overlay={menuDropdown}
						key={`submenu${index}`}
						placement='bottomLeft'
						overlayClassName='dropdown-menu-header'
					>
						<div
							className={classNames({
								'rounded-8px py-10px px-20px cursor-pointer transition-all duration-300 mr-5px hover:bg-white hover:bg-opacity-20': true,
								'bg-transparent': !hasActive,
								'bg-white bg-opacity-20 border-opacity-30 border-1 border-solid border':
									hasActive,
							})}
						>
							<div className='flex justify-between text-white'>
								<div className='text-16px text-white leading-19px title-head-menu hover:opacity-80'>
									<p className='line-clamp-1 text-16px font-averta-bold'>
										{item.menuName.toLowerCase()}
									</p>
								</div>
								<p className='transform rotate-90 text-12px ml-8px'>►</p>
							</div>
						</div>
					</Dropdown>
				);
			}
		});
	};

	return (
		<div className='header-layout h-125px bg-menu-bottom relative flex-shrink-0 overflow-hidden'>
			<img src={imgBgLogin} alt='' className='bg-round-header' />
			<div className='absolute left-0 top-0 w-full h-full pt-30px md:pt-0'>
				<Header />
				<div className='md:px-24px'>
					{!isMobile && (
						<div className='ml-400px flex items-center'>
							<div className='w-24px'></div>
							<Item
								value={KEY_MENU.home}
								link={AppRoutes.home}
								text='Trang chủ'
								icon={<img src={iconHome} />}
							/>
							{isShowContract && (
								<Item
									value={KEY_MENU.contract}
									link={ContractRoutes.contract}
									text='Hợp đồng'
									icon={<img src={iconCertificate} />}
								/>
							)}
							{isShowGift && (
								<Item
									value={KEY_MENU.gift}
									link={AppRoutes.gift}
									text='Quà tặng'
									icon={<img src={iconGift} />}
								/>
							)}
							{renderMenuApi()}
							{!isAdmin && (
								<>
									<Item
										value={KEY_MENU.service}
										link={AppRoutes.productsAndServices}
										text='Dịch vụ'
										icon={<img src={iconService} />}
									/>
									<Item
										value={KEY_MENU.contact}
										link={AppRoutes.contactUs}
										text='Liên hệ'
										icon={<img src={iconTeleWhite} />}
									/>
								</>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

const Item = ({ text, icon, link, value, isActiveProp }) => {
	const menuActive = useActiveMenu();
	const isActive = isActiveProp ?? value === menuActive;
	const navigate = useNavigate();

	const onChange = () => {
		if(link !== '/pages/loyalty-store'){
			window.location.href = `${LINK_DEV}${link}`
		}
		// else{
			// navigate(link);
		// }
	};

	return (
		<div
			onClick={onChange}
			className={classNames({
				'rounded-8px py-10px px-20px cursor-pointer transition-all duration-300 mr-5px hover:bg-white hover:bg-opacity-20': true,
				'bg-transparent': !isActive,
				'bg-white bg-opacity-20 border-opacity-30 border-1 border-solid border':
					isActive,
			})}
		>
			<div className='text-16px text-white leading-19px flex items-center hover:opacity-80'>
				{icon && <div className='mr-12px'>{icon}</div>}
				<div className='title-head-menu'>
					<p className='text-16px line-clamp-1 font-averta-bold'>{text}</p>
				</div>
			</div>
		</div>
	);
};
